import React from "react";
import { Tag } from "antd";
import { SmallTitle } from "../Typography/Titles";
import { SvgIcons } from "Icon/SvgIcons";

// Define the type for the props
interface CustomTagWithPlusProps {
  value: string;
  isSelected?: boolean;
  isSmall?: boolean;
  handleClick?: (value: string) => void;
  otherIcon?: React.ReactNode;
  variant?: "primary" | "secondary";
  hideIcon?: boolean;
}

const CustomTagWithPlus: React.FC<CustomTagWithPlusProps> = ({
  value,
  isSelected = false, // Default value for isSelected
  isSmall = false, // Default value for isSelected
  handleClick,
  otherIcon,
  variant = "primary", 
  hideIcon
}) => {
  const handleTagClick = (event: React.MouseEvent<HTMLSpanElement>) => {
    event.preventDefault();
    if (handleClick) {
      handleClick(value);
    }
  };

  const getStyles = () => {
    if (variant === "primary") {
      return {
        color: "black",
        border: `1px solid ${isSelected ? "#9E77ED" : "#B9E6FE"}`,
        backgroundColor: isSelected ? "#F9F5FF" : "#F0F9FF",
      };
    } else {
      return {
        color: "#344054",
        border: `1px solid ${isSelected ? "#E4E7EC" : "#E4E7EC"}`,
        backgroundColor: isSelected ? "#F9FAFB" : "#F9FAFB",
      };
    }
  };

  const getTextColor = () => {
    if (variant === "primary") {
      return `${isSelected ? "text-brand-700" : "text-blue-light-700"} font-medium`;
    } else {
      return "text-text-secondary font-medium";
    }
  };

  const getPadding = () => {
    if (isSmall) {
      return "2px 2px 2px 4px";
    } else {
      return "2px 4px 2px 8px";
    }
  };

  const textSize = () => {
    if (isSmall) {
      return "text-xs";
    } else {
      return "";
    }
  };

  return (
    <Tag
      onClick={handleTagClick}
      style={{
        ...getStyles(),
        display: "inline-flex",
        alignItems: "center",
        gap: "2px",
        marginInlineEnd: "0",
        cursor: "pointer",
        padding: getPadding(),
      }}
    >
      <SmallTitle text={value} font="font-medium capitalize" className={`${getTextColor()} ${textSize()}`} />
      {!hideIcon && !otherIcon ? (isSelected ? SvgIcons.smallCrossSvg : SvgIcons.bluePlusSvg) : otherIcon}
    </Tag>
  );
};

export default CustomTagWithPlus;
